import React, { useEffect, useState } from 'react';
import { arrayOf, node, object, oneOfType, string } from 'prop-types';

import './styles.scss';

function ClipBoardBlock({ children, style = {}, className = '', copy = true }) {
  const [show, setShow] = useState(false);
  const onCopy = () => {
    navigator.clipboard.writeText(children);
    setShow(true);
  };

  useEffect(() => {
    setTimeout(() => {
      if (show) setShow(false);
    }, 1000);
  }, [show]);

  return (
    <span
      style={{ ...style }}
      className={`terminal-command ${className} position-relative p-2 pr-4`}
    >
      <code>{children}</code>
      {copy && (
        <span
          className={`icon_documents_alt pointer position-absolute ${
            !show ? 'show' : 'hide'
          }`}
          style={{ top: 3, right: 3 }}
          onClick={onCopy}
        />
      )}
      <span
        className={`bg-success text-white d-flex justify-content-center align-items-center position-absolute ${
          show ? 'show' : 'hide'
        }`}
        style={{ top: 0, right: 0, left: 0, bottom: 0 }}
      >
        Copied!
      </span>
    </span>
  );
}

ClipBoardBlock.propTypes = {
  children: oneOfType([string, node, arrayOf(node)]),
  className: string,
  style: object,
};

export default ClipBoardBlock;
